<template>
  <div>
    <div v-if="options && broker">
      <v-dialog scrollable v-model="loading" persistent max-width="200">
        <v-card>
          <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-layout row justify-center>
                <v-flex xs12 sm6 md4 lg3>
                  <v-progress-circular indeterminate></v-progress-circular>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <sick-payment-settings-dialog
      v-if="dialogs.add"
        :model="dialogs.add"
        @close="dialogs.add = false"
        @saved="
          dialogs.add = false;
          $refs.table.getDataAsync();
        "
        :brokerId="broker.Id"
      />
      <sick-payment-settings-dialog
      v-if="dialogs.edit"
        :model="dialogs.edit"
        @close="dialogs.edit = false"
        @saved="
          dialogs.edit = false;
          $refs.table.getDataAsync();
          $refs.submissionTable.getDataAsync();
          $refs.adjudicationTable.getDataAsync();
        "
        :id="selectedItemId"
        :brokerId="broker.Id"
        :planName="planName"
      />
      <material-card
        v-if="broker !== null || broker !== undefined"
        :title="
          $t('views.sick_payment.sick_hours_bank_settings')
        "
        :color="$vuetify.theme.themes.light.primary"
        icon="file_copy"
      >
        <pbas-data-table
          ref="table"
          :exporters="$exporters"
          :dataProvider="provider"
          :showSelect="false"
          :floatActions="floatActions"
          :rowActions="rowActions"
          identifier="sickHourBankSettingsTable"
          @error="error = $event"
        ></pbas-data-table>
      </material-card>
      <!-- <material-card
        v-if="broker !== null || broker !== undefined"
        :title="
          $t('views.sick_payment.sick_day_submission_settings')
        "
        color="#007cb5"
        icon="file_copy"
      >
        <pbas-data-table
          ref="submissionTable"
          :exporters="$exporters"
          :dataProvider="sickDaySubmissionSettingsProvider"
          :showSelect="false"
          identifier="sickDaySubmissionSettingsTable"
          @error="error = $event"
        ></pbas-data-table>
      </material-card>
      <material-card
        v-if="broker !== null || broker !== undefined"
        :title="
          $t('views.sick_payment.sick_day_adjudication_settings')
        "
        color="#007cb5"
        icon="file_copy"
      >
        <pbas-data-table
          ref="adjudicationTable"
          :exporters="$exporters"
          :dataProvider="sickDayAdjudicationSettingsProvider"
          :showSelect="false"
          identifier="sickDayAdjudicationSettingsTable"
          @error="error = $event"
        ></pbas-data-table>
      </material-card> -->
      <error-handler :error="error"></error-handler>
    </div>
    <div v-else>
      <v-row justify="center">
        <v-progress-circular
          :size="70"
          :width="7"
          color="purple"
          indeterminate
        ></v-progress-circular>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ODataProvider } from "pbas-vue-components";
import SickHourBankSettingsHeaders from "../headers/SickHourBankSettings";
import SickDaySubmissionSettingsHeaders from "../headers/SickDaySubmissionSettings";
import SickDayAdjudicationSettingsHeaders from "../headers/SickDayAdjudicationSettings";
import ErrorHandler from "../components/ErrorHandler";
import SickPaymentSettingsDialog from "../components/SickPaymentSettings/SickPaymentSettingsDialog.vue";
import { translate2 } from "../trans2";

export default {
  components: {
    ErrorHandler,
    SickPaymentSettingsDialog,
  },
  data() {
    return {
      loading: false,
      broker: null,
      error: null,
      provider: undefined,
      // sickDaySubmissionSettingsProvider: undefined,
      // sickDayAdjudicationSettingsProvider: undefined,
      saving: false,
      selectedItemId: null,
      planName: null,
      floatActions: [
        {
          text: "globals.add_new",
          name: "add",
          icon: "add",
          color: "#64ba5f",
          handler: () => {
            this.selectedItemId = null;
            this.dialogs.add = true;
          },
        },
      ],
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.view_edit",
          handler: async (item) => {
            this.selectedItemId = item.Id;
            this.dialogs.edit = true;
          },
        },
      ],
      dialogs: {
        add: false,
        edit: false,
      },
    };
  },
  computed: {
    ...mapGetters("odata", { storeSearch: "search" }),
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", ["language", "settings"]),
  },
  watch: {
    broker: {
      async handler(v) {
        console.log("broker: ", this.headers, this.broker);
        if (v) {
          this.provider = new ODataProvider(
            this.$axiosHttp,
            "sick-hour-bank-settings/brokers/" + v.Id,
            SickHourBankSettingsHeaders
          );
          // this.sickDaySubmissionSettingsProvider = new ODataProvider(
          //   this.$axiosHttp,
          //   "sick-day-submission-settings/brokers/" + v.Id,
          //   SickDaySubmissionSettingsHeaders
          // );
          // this.sickDayAdjudicationSettingsProvider = new ODataProvider(
          //   this.$axiosHttp,
          //   "sick-day-adjudication-settings/brokers/" + v.Id,
          //   SickDayAdjudicationSettingsHeaders
          // );
        }
      },
    },
  },
  async mounted() {
    console.log("mounted: ", this.options, this.broker);
    try {
      this.broker = (
        await this.getOrganizationById({
          id: this.$route.params.broker,
        })
      ).data;
    } catch (error) {
      this.error = error;
    }
  },
  methods: {
    ...mapActions("plansMembers", ["getOrganizationById", "getPlan"]),
  },
};
</script>
